<template>
  <div>

    <b-container fluid>
      <b-row>
        <b-col>
          <h2 class="pb-3">Ativar módulo <code>Impressão</code></h2>

          <p>Para ativar o módulo de <strong>Impressão de Ingressos</strong> do aplicativo <u>Easytick</u> siga os passos:</p>

          <ol>
            <li class="pb-3"><b-link :to="{ name: 'OrganizerBatches' }">Crie os lotes</b-link> do seu evento ou bar;</li>
            <li class="pb-3"><b-link :to="{ name: 'OrganizerDealers' }">Crie um revendedor</b-link> para seu evento ou bar;</li>
            <li class="pb-3">Na <b-link :to="{ name: 'OrganizerDealers' }">gestão de revendedores</b-link>, ative a chave <code>Impressão via Web e App</code> do seu revendedor;</li>
            <li class="pb-3">Ainda na <b-link :to="{ name: 'OrganizerDealers' }">gestão de revendedores</b-link>, detalhe o revendedor clicando no botão lupa <icon name="search" class="mx-0"></icon>;</li>
            <li class="pb-3">Abra o aplicativo <u>Easytick</u>;</li>
            <li class="pb-3">Na primeira tela do aplicativo toque no botão <code>IMPRIMIR INGRESSOS</code>;</li>
            <li class="pb-3">Leia o QRCode do revendedor usando o aplicativo <u>Easytick</u>;</li>
          </ol>


        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
export default {
  name: 'OrganizerAppPrint',
  data () {
    return {
      event: {}
    }
  },
  mounted () {
    this.organizer = this.$route.params.organizer
    this.getEvent()
  },
  methods: {
    getEvent () {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/events'

      return this.$http.get(url).then(res => {
        this.event = res.body
      }, err => {
        console.log(err)
      })
    }
  }
}
</script>
